import { render, staticRenderFns } from "./exchangeForum.vue?vue&type=template&id=7312f09d&scoped=true"
import script from "./exchangeForum.vue?vue&type=script&lang=js"
export * from "./exchangeForum.vue?vue&type=script&lang=js"
import style0 from "./exchangeForum.vue?vue&type=style&index=0&id=7312f09d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312f09d",
  null
  
)

export default component.exports